import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-complexity-view',
  templateUrl: './project-complexity-view.component.html',
  styleUrls: ['./project-complexity-view.component.scss']
})
export class ProjectComplexityViewComponent implements OnInit {

  constructor(
    public router: Router
  ) {
  }

  ngOnInit(): void {
  }

}
